var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-row', [_c('b-col', {
    attrs: {
      "col": ""
    }
  }, [_c('b-card', {
    staticClass: "card-titulo-itens",
    attrs: {
      "title": "Venda em Andamento"
    }
  }), _c('b-card', {
    staticClass: "card-itens tableItensPdv",
    attrs: {
      "id": "tableItensPdv"
    }
  }, [_c('table', {
    staticClass: "table table-head-custom table-head-bg table-vertical-center"
  }, [_c('thead', [_c('tr', [_c('th'), _c('th', {
    staticClass: "pl-0 font-weight-bold text-muted pl-7"
  }, [_vm._v(" Produto"), _c('br'), _vm._v("Código de Barras ")]), _c('th', {
    staticClass: "text-right pr-0 font-weight-bold text-muted"
  }, [_vm._v(" Un. Medida ")]), _c('th', {
    staticClass: "text-right pr-0 font-weight-bold text-muted"
  }, [_vm._v(" Quant. ")]), _c('th', {
    staticClass: "text-right pr-0 font-weight-bold text-muted"
  }, [_vm._v(" Unitário ")]), _c('th', {
    staticClass: "text-right pr-0 font-weight-bold text-muted pr-7"
  }, [_vm._v(" Total ")])])]), _c('tbody', _vm._l(_vm.items, function (i, index) {
    return _c('tr', {
      key: 'item' + index,
      class: !i.active ? 'font-weight-boldest font-size-lg cancelado' : 'font-weight-boldest font-size-lg'
    }, [_c('td', [_vm._v(_vm._s(parseFloat(index + 1)))]), _c('td', {
      staticClass: "pl-0"
    }, [_c('a', {
      staticClass: "text-dark font-weight-bolder text-hover-primary mb-1 font-size-lg pl-7",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(" " + _vm._s(i.product.descricao) + " ")]), _c('span', {
      staticClass: "text-muted font-weight-bold d-block pl-7"
    }, [_vm._v(" " + _vm._s(i.product.cod_barras) + " ")])]), _c('td', {
      staticClass: "text-right pr-0 pt-7"
    }, [_vm._v(" " + _vm._s(i.product.unidade_medida.un) + " ")]), _c('td', {
      staticClass: "text-right pr-0 pt-7"
    }, [i.active ? _c('a', {
      staticClass: "btn btn-xs btn-light-success btn-icon mr-2",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function click($event) {
          return _vm.substract(index);
        }
      }
    }, [_c('i', {
      staticClass: "ki ki-minus icon-xs"
    })]) : _vm._e(), _c('span', {
      staticClass: "mr-2 font-weight-bolder"
    }, [_vm._v(_vm._s(_vm.valorReal(i.quantity, true)))]), i.active ? _c('a', {
      staticClass: "btn btn-xs btn-light-success btn-icon",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function click($event) {
          return _vm.add(index);
        }
      }
    }, [_c('i', {
      staticClass: "ki ki-plus icon-xs"
    })]) : _vm._e()]), _c('td', {
      staticClass: "text-right pr-0 pt-7"
    }, [_vm._v(" R$ " + _vm._s(_vm.valorReal(i.product.preco, true)) + " ")]), _c('td', {
      staticClass: "text-right pr-0 pr-7 pt-7"
    }, [_vm._v(" R$ " + _vm._s(_vm.valorReal(i.totalPrice)) + " ")])]);
  }), 0)])]), _c('blockquote')], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };